var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRowSpacingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.529,
    height: 18.379,
    viewBox: "0 0 22.529 18.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9575",
    "data-name": "Group 9575",
    transform: "translate(893.245 22860.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27459",
    "data-name": "Path 27459",
    d: "M75.284,5.15h12a1,1,0,1,0,0-2h-12a1,1,0,0,0,0,2",
    transform: "translate(-959 -22861)",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27460",
    "data-name": "Path 27460",
    d: "M87.284,14.849h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2",
    transform: "translate(-959 -22861)",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27461",
    "data-name": "Path 27461",
    d: "M87.284,9h-12a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2",
    transform: "translate(-959 -22861)",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27462",
    "data-name": "Path 27462",
    d: "M70.728,4.857a1,1,0,1,0,1.414-1.414L69.8,1.1a1.014,1.014,0,0,0-.326-.216,1,1,0,0,0-1.089.216l-2.34,2.34a1,1,0,0,0,1.414,1.414l.633-.633V15.776l-.633-.633a1,1,0,0,0-1.414,1.414l2.339,2.34a1,1,0,0,0,1.093.216A1,1,0,0,0,69.8,18.9l2.339-2.34a1,1,0,0,0-1.414-1.414l-.633.633V4.224Z",
    transform: "translate(-959 -22861)",
    fill: "#FFCC00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowSpacingIcon);
export default __webpack_public_path__ + "static/media/RowSpacingIcon.69b9815a638d2fb4c46d469fad42d2c2.svg";
export { ForwardRef as ReactComponent };